import OverView from './Overview.gql';

export default OverView;
